module.exports = __webpack_public_path__ + "img/register.c885061a.png";